import {
  ITableColumn,
  TableActionButtonTypeEnum,
  TableActionsEnum,
  TableFieldTypeEnum
} from '@common/shared';

export const TASKS_TABLE_COLUMNS: ITableColumn[] = [
  {
    title: '№',
    field: 'order'
  },
  {
    field: 'icon',
    fieldType: TableFieldTypeEnum.ICON,
    icons: {
      field: 'isTask',
      icon: 'heroicons_outline:document-check',
      title: 'Задача',
      iconAlt: 'heroicons_outline:document-text',
      titleAlt: 'Решение'
    }
  },
  {
    title: 'Наименование задачи',
    field: 'title',
    fieldType: TableFieldTypeEnum.LINK,
    linkField: 'taskLink'
  },
  {
    title: 'Исполнитель',
    field: 'assigneeArray',
    fieldType: TableFieldTypeEnum.ARRAY,
    isHistoryArray: true
  },
  {
    title: 'Дата заседания',
    field: 'committeeEventTime',
    fieldType: TableFieldTypeEnum.DATE,
    format: 'dd.MM.yyyy'
  },
  {
    title: 'План',
    field: 'deadlineArray',
    fieldType: TableFieldTypeEnum.ARRAY,
    isHistoryArray: true
  },
  {
    title: 'Факт',
    field: 'completeDate',
    fieldType: TableFieldTypeEnum.DATE,
    format: 'dd.MM.yyyy'
  },
  {
    title: 'Образ результата',
    field: 'resultRepresentation'
  },
  {
    title: 'Статус',
    field: 'projectStatusString'
  },
  {
    field: 'actions',
    fieldType: TableFieldTypeEnum.ACTION,
    buttons: [
      {
        action: TableActionsEnum.EDIT,
        type: TableActionButtonTypeEnum.ICON,
        icon: 'heroicons_outline:pencil',
        title: 'Внести решение по задаче'
      }
    ]
  }
];
